var React = require('react');

function LocationInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.3051 0.70752C7.17236 0.70752 3.81006 4.06982 3.81006 8.20254C3.81006 13.3969 11.3125 22.27 11.3125 22.27C11.3125 22.27 18.8001 13.1415 18.8001 8.20254C18.8001 4.06982 15.4379 0.70752 11.3051 0.70752ZM13.5665 10.3971C12.9429 11.0205 12.1241 11.3323 11.3051 11.3323C10.4862 11.3323 9.6671 11.0205 9.04381 10.3971C7.79683 9.15024 7.79683 7.12139 9.04381 5.87441C9.64762 5.27034 10.4508 4.93763 11.3051 4.93763C12.1593 4.93763 12.9624 5.27047 13.5665 5.87441C14.8135 7.12139 14.8135 9.15024 13.5665 10.3971Z","fill":"white"}));
}

LocationInline.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = LocationInline;

LocationInline.default = LocationInline;
